var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyMuscleRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03591 40.6107C6.29391 43.8407 16.1179 46.3747 20.7599 40.3307C25.7799 42.7307 34.0579 41.9867 40.7999 38.2267C41.7359 37.7067 42.6219 37.0467 43.1659 36.1187C44.3919 34.0287 44.4199 31.1287 42.1839 26.8507C38.4539 17.5427 31.7479 9.37071 29.0399 6.08471C28.4839 5.57871 24.9379 4.85871 22.7739 4.16471C21.8179 3.87071 20.0399 3.67471 17.9139 6.47871C16.9039 7.80671 12.3219 11.0727 18.1339 13.2667C19.0359 13.4967 19.6979 13.9187 23.8079 13.1687C24.3419 13.0767 25.6779 13.1687 26.6199 14.8207L28.5879 17.6347C28.772 17.8954 28.8881 18.1978 28.9259 18.5147C29.2699 21.5127 29.2579 25.2647 30.9299 27.1667C28.3499 25.2987 21.6019 23.0827 16.5179 29.3907M4.00391 25.8807C6.29257 23.8408 9.21038 22.6455 12.2724 22.4934C15.3345 22.3413 18.3564 23.2416 20.8359 25.0447",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMuscleRate);
export default __webpack_public_path__ + "static/media/bodyMuscleRate.d70ce839fee258352c5052c96b680a3a.svg";
export { ForwardRef as ReactComponent };